module.exports = __webpack_public_path__ + "img/jjooJuventud3.8874d29e.jpg";